<template>
  <v-app-bar app color="primary" dark flat v-if="showTopBar">
    <div class="menu-wrapper" v-if="mobile || tablet" @click="$emit('click')">
      <v-badge
        color="orange"
        :value="notificationCount"
        :content="notificationCount"
        overlap
      >
        <v-app-bar-nav-icon></v-app-bar-nav-icon>
      </v-badge>
    </div>

    <v-toolbar-title color="white">{{ title }}</v-toolbar-title>
    <v-spacer />
    <avatar />
  </v-app-bar>
</template>

<script>
import checkMobileMixin from "Shared/mixins/checkMobileMixin";
import Avatar from "Public/components/AppBar/components/avatar";
import checkTabletMixin from "Shared/mixins/checkTabletMixin";
import checkIsChatMixin from "Shared/mixins/checkIsChatMixin";

export default {
  name: "PublicAppBar",
  components: { Avatar },
  mixins: [checkMobileMixin, checkTabletMixin, checkIsChatMixin],
  props: {
    notificationCount: {
      type: Number,
      default: 0,
    },
  },
  computed: {
    showTopBar() {
      return !(this.isChat && this.mobile);
    },
    title() {
      const { sectionTitle, mobileTitle } = this.$route.meta;
      if (sectionTitle !== mobileTitle) {
        return `${sectionTitle} ${mobileTitle}`;
      }
      return sectionTitle;
    },
  },
};
</script>

<style lang="scss" scoped>
.menu-wrapper {
  width: 64px;

  .v-size--default {
    height: 32px !important;
    width: 32px !important;
  }
}
</style>
